module.exports = __webpack_public_path__ + "img/CA.19154df3.svg";